import { render, staticRenderFns } from "./LoginEmailSentView.vue?vue&type=template&id=2c20e2f0&scoped=true"
import script from "./LoginEmailSentView.vue?vue&type=script&lang=js"
export * from "./LoginEmailSentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20e2f0",
  null
  
)

export default component.exports